<template>
    <div :class="getThemeClass(type)">
        <common-icon v-if="isActive" class="theme-card__icon" name="theme-selected" size="extra-huge"></common-icon>
        <div>
            <div class="theme-card__title">{{ getThemeName(type) }}</div>
            <div :class="`theme-card-${type}__first-div`"></div>
            <div :class="`theme-card-${type}__second-div`">
                <div :class="`theme-card-${type}__second-div__inside`"></div>
                <div :class="`theme-card-${type}__second-div__inside`"></div>
                <div :class="`theme-card-${type}__second-div__inside`"></div>
            </div>
            <div>
                <common-button
                    :class="getButtonsClass(type)"
                    type="secondary"
                    size="small"
                    :isFluid="true"
                    :label="$t('pages.company.create_company.view')"
                    :isSubmittable="false"
                    @click.stop="choosePackage(type)"
                ></common-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: { type: String, required: true },
            isActive: { type: Boolean, default: false },
        },

        methods: {
            getThemeClass(themeClass) {
                return {
                    'theme-card': true,
                    'theme-card__element': true,
                    [`theme-card-${themeClass}`]: true,
                }
            },

            getButtonsClass(themeClass) {
                return {
                    'theme-card__button': true,
                    [`theme-card-${themeClass}__button`]: true,
                }
            },

            getThemeName(name) {
                return name.toUpperCase().replace(/_/g, ' ')
            },

            choosePackage(theme) {
                this.emitEvent({ name: 'theme-preview', payload: theme })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/subdomain/_theme-card.scss';
</style>
